import * as _ from 'lodash';

var templateUrl = require('./login.html');

angular.module('ciApp').component('login', {
  templateUrl: templateUrl,
  controller: [
    '$location',
    'AuthService',
    'SiteSwitcherService',
    '$state',
    '$rootScope',
    LoginController
  ]
});

function LoginController($location, AuthService, SiteSwitcherService, $state, $rootScope) {
  const vm = this;

  vm.$onInit = function() {
    var token = $location.search()['auth-token'];
    if (token) {
      vm.tokenLogin = true;
      AuthService.tokenLogin(token).then(vm.handleLoginSuccess).catch(vm.handleLoginFailure);
    }
  };

  vm.handleLoginSuccess = function() {
    $rootScope.$broadcast('userLoggedIn');
    AuthService.goHome();
  };

  vm.handleLoginFailure = function(error) {
    // TODO: this treats all errors as wrong username or password,
    // need to make it catch/rethrow the error if it's something else
    if (vm.tokenLogin) {
      vm.error = "We couldn't log you in, please try again";
    } else {
      vm.error = 'Your username or password were incorrect, please try again';
    }

    vm.tokenLogin = false;
  };

  vm.login = function() {
    AuthService.login(vm.email, vm.password)
      .then(vm.handleLoginSuccess)
      .catch(vm.handleLoginFailure);
  };
}



// WEBPACK FOOTER //
// ./app/login/login.component.js